export const SusSvg = ({
  width = 48,
  height = 48,
  style = {},
}: any) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>编组 2</title>
    <g id="红白" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="订单状态-支付成功备份" transform="translate(-164.000000, -143.000000)">
            <g id="编组" transform="translate(20.000000, 127.000000)">
                <g id="status_pay_successfully" transform="translate(128.000000, 0.000000)">
                    <g id="编组-2" transform="translate(16.000000, 16.000000)">
                        <rect id="矩形" x="0" y="0" width="48" height="48"></rect>
                        <path d="M42.7141798,11.4324678 C43.6904905,12.4087786 43.6904905,13.991691 42.7141798,14.9680017 L20.1636179,37.5185636 C20.0336917,37.6484898 19.8930226,37.7611256 19.7444699,37.856471 C18.7748645,38.4892467 17.4622414,38.3802855 16.6108841,37.5289282 L6.00428242,26.9223265 C5.02797169,25.9460157 5.02797169,24.3631033 6.00428242,23.3867926 C6.98059315,22.4104818 8.5635056,22.4104818 9.53981633,23.3867926 L18.3819426,32.229128 L39.1786458,11.4324678 C40.1549566,10.4561571 41.737869,10.4561571 42.7141798,11.4324678 Z" id="Combined-Shape" fill="var(--certify-primary-color)" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
  </svg>
)

export const ErrSvg = ({
  width = 48,
  height = 48,
  style = {},
}: any) => (
  <svg
    style={{ ...style }}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>编组 2</title>
    <g id="红白" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="订单状态-支付失败备份" transform="translate(-169.000000, -143.000000)">
            <g id="编组" transform="translate(20.000000, 127.000000)">
                <g id="status_pay_successfully" transform="translate(133.000000, 0.000000)">
                    <g id="编组-2" transform="translate(16.000000, 16.000000)">
                        <rect id="矩形" x="0" y="0" width="48" height="48"></rect>
                        <path d="M14.1636179,12.4324678 L23.6708509,21.9392348 L33.1786458,12.4324678 C34.1549566,11.4561571 35.737869,11.4561571 36.7141798,12.4324678 C37.6904905,13.4087786 37.6904905,14.991691 36.7141798,15.9680017 L27.2058509,25.4752348 L36.7141798,34.9830297 C37.6904905,35.9593405 37.6904905,37.5422529 36.7141798,38.5185636 C35.737869,39.4948744 34.1549566,39.4948744 33.1786458,38.5185636 L23.6708509,29.0102348 L14.1636179,38.5185636 C13.1873071,39.4948744 11.6043947,39.4948744 10.628084,38.5185636 C9.65177322,37.5422529 9.65177322,35.9593405 10.628084,34.9830297 L20.1348509,25.4752348 L10.628084,15.9680017 C9.65177322,14.991691 9.65177322,13.4087786 10.628084,12.4324678 C11.6043947,11.4561571 13.1873071,11.4561571 14.1636179,12.4324678 Z" id="Combined-Shape" fill="var(--certify-primary-color)" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
  </svg>
)